import { format } from 'd3';

export const formatNumber = format(',.0f');
export const formatPercent = format('.0%');
